import { ENewReviewFlow, ENewReviewMode, ENewReviewStep } from '../../types/newReview';
import { NEW_REVIEW_NOT_CONTENT_STEPS } from '../../constants/reviews';

export function getFormMode(flow: ENewReviewFlow | null) {
  if (flow) {
    return ENewReviewMode.SkipFlow;
  }

  return ENewReviewMode.Full;
}

export function getStepsList(mode: ENewReviewMode): ENewReviewStep[] {
  if (mode === ENewReviewMode.SkipFlow) {
    return [ENewReviewStep.Rating, ENewReviewStep.Review, ENewReviewStep.Success];
  }

  return [ENewReviewStep.FlowSelection, ENewReviewStep.Rating, ENewReviewStep.Review, ENewReviewStep.Success];
}

export function getFirstStep(mode: ENewReviewMode): ENewReviewStep {
  return getStepsList(mode)[0];
}

export function getIsNextStepAvailable(step: ENewReviewStep, mode: ENewReviewMode) {
  const steps = getStepsList(mode);

  return steps.indexOf(step) < steps.length - 1;
}

export function getNextStep(step: ENewReviewStep, mode: ENewReviewMode) {
  const steps = getStepsList(mode);
  const index = steps.indexOf(step);
  const nextStep = steps[index + 1];

  if (!nextStep) {
    return step;
  }

  return nextStep;
}

export function getIsPrevStepAvailable(step: ENewReviewStep, mode: ENewReviewMode) {
  const steps = getStepsList(mode);
  const index = steps.indexOf(step);

  return index > 0;
}

export function getPrevStep(step: ENewReviewStep, mode: ENewReviewMode) {
  const steps = getStepsList(mode);
  const index = steps.indexOf(step);

  if (index <= 0) {
    return step;
  }

  return steps[index - 1];
}

export function getLastContentStep(mode: ENewReviewMode): ENewReviewStep {
  const steps = getStepsList(mode);

  for (let i = steps.length - 1; i >= 0; i--) {
    if (!NEW_REVIEW_NOT_CONTENT_STEPS.includes(steps[i])) {
      return steps[i];
    }
  }

  return steps[0];
}
